"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendMessageButton = SendMessageButton;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
require("./SendMessageButton.less");
var _excluded = ["sendMessage"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function SendMessageButton(props) {
  var _props$sendMessage = props.sendMessage,
    sendMessage = _props$sendMessage === void 0 ? _utils.noop : _props$sendMessage,
    sendButtonProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_button.default, _extends({
    className: "send-msg-btn",
    type: "link"
  }, sendButtonProps, {
    onClick: sendMessage
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "27",
    height: "25",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 17.015l17.333-8.508L0 0v6.617l12.417 1.89L0 10.397z",
    fillRule: "evenodd",
    fill: "#006cff"
  })));
}